<template>
	<div class="content">
		<h3>入库单统计</h3>
		<div class="item">
			<el-form ref="selectfactoryForm" inline  :model="selectfactoryForm" label-width="80px">
				<el-form-item label="时间类型">
					<el-input v-model="selectfactoryForm.factoryCode"></el-input>
				</el-form-item>
				<el-form-item label="开始时间">
					<el-date-picker
						v-model="form.endtime" value-format="yyyy-MM-dd"
						type="date"
						placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
                <el-form-item label="结束时间">
					<el-date-picker
						v-model="form.endtime" value-format="yyyy-MM-dd"
						type="date"
						placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
                <el-form-item label="入库单号">
					<el-input v-model="selectfactoryForm.factoryName"></el-input>
				</el-form-item>
                <el-form-item label="产品">
					<el-input v-model="selectfactoryForm.factoryName"></el-input>
				</el-form-item>
				<el-form-item label="入库库房">
					<el-select v-model="selectfactoryForm.isActive" clearable placeholder="请选择">
						<el-option
						v-for="item in state"
						:key="item.value"
						:label="item.lable"
						:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="入库类型">
					<el-select v-model="selectfactoryForm.isActive" clearable placeholder="请选择">
						<el-option
						v-for="item in state"
						:key="item.value"
						:label="item.lable"
						:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="数码">
					<el-input v-model="selectfactoryForm.factoryName"></el-input>
				</el-form-item>
				<el-form-item style="width:800px;margin:0 80px;">
					<el-checkbox v-model="form.checked1">只看单据计划量与处理成功数量不一致的单据</el-checkbox>
				</el-form-item>
                 <el-form-item style="width:800px;margin:0 80px;">
					<el-checkbox v-model="form.checked2">显示已删除、已覆盖的单据</el-checkbox>
				</el-form-item>
			</el-form>
			<div class="btn">
				<el-button type="primary"  @click="SelFactory">查 询</el-button>
				<el-button type="warning">重 置</el-button>
			</div>
		</div>
		<div class="item">
			<el-table :data="tableData" border>
				<el-table-column prop="FactoryName" label="入库单号"></el-table-column>
				<el-table-column prop="FactoryCode" label="产品编号"></el-table-column>
				<el-table-column prop="Address" label="产品名称"></el-table-column>
                <el-table-column prop="Address" label="包装比例"></el-table-column>
                <el-table-column prop="Address" label="创建时间"></el-table-column>
				<el-table-column prop="Address" label="更新时间"></el-table-column>
                <el-table-column prop="Address" label="入库库房"></el-table-column>
                <el-table-column prop="Address" label="入库类型"></el-table-column>
                <el-table-column prop="Address" label="退货经销商"></el-table-column>
                <el-table-column prop="Address" label="操作员"></el-table-column>
				<el-table-column label="查看异常" >
					<template slot-scope="scope">
						<el-button type="text" @click="EditFactory(scope)">查看</el-button>
					</template>
				</el-table-column>
                <el-table-column prop="Address" label="托数量"></el-table-column>
                <el-table-column prop="Address" label="箱数量"></el-table-column>
                <el-table-column prop="Address" label="盒数量"></el-table-column>
                <el-table-column prop="Address" label="小计"></el-table-column>
			</el-table>
			<el-pagination background
			@current-change="handleCurrentChange"
			layout="total,prev, pager, next,jumper"
			:total="pageNum"
			:page-size="10">
			</el-pagination>
		</div>
	</div>
</template>

<script>
import {validateNumber} from '../utils/rules'
export default {
	data(){
		return {
			form:{
				checked1:'',
				checked2:'',
			},
			tableData: [],
			state:[{
				value:'0',
				lable:"禁用"
			},{
				value:'1',
				lable:"启用"
			}],
			dialogVisible:false,
			dialogtype:0,
			editVisible:true,
			selectfactoryForm:{
				factoryName:'',//工厂名称
				factoryCode:'',//工厂编号
				activeFlag:'',//状态
			},
			factoryForm:{
				factoryName:'',//工厂名称
				factoryCode:'',//工厂编号
				cid:'',//企业id
				note:'',//备注
				linkTel:'',//电话
				linkMan:'',//联系人
				address:'',//地址
				isActive:1,//状态
				DataId:"0"
			},
			rules: {
        		factoryName:[
          			{ required: true, message: '请输入一个工厂名称', trigger: 'change' }
        		],
        		factoryCode:[
          			{ required: true, validator: validateNumber, message: '请输入工厂编码号,数字类型', trigger: 'blur' }
        		],
        		linkTel:[
          			{ required: true,  message: '请输入联系人电话', trigger: 'blur' }
				],
				linkMan:[
					{ required: true,  message: '请输入联系人姓名', trigger: 'blur' },
				],
				address:[
          			{ required: true,  message: '请输入工厂地址', trigger: 'blur' }
				],
			},
			pageNum:0
		}
	},
	methods: {
		AddFactory(){
			this.editVisible=false
			this.dialogVisible=true;
			this.dialogtype=1;
		},
		EditFactory(factory){
			this.editVisible=true
			this.dialogVisible=true;
			this.dialogtype=2;
			this.$nextTick(() => {
				this.factoryForm.factoryName=factory.row.FactoryName;
				this.factoryForm.factoryCode=factory.row.FactoryCode;
				this.factoryForm.address=factory.row.Address;
				this.factoryForm.linkTel=factory.row.LinkTel;
				this.factoryForm.linkMan=factory.row.LinkMan;
				this.factoryForm.isActive=factory.row.IsActive;
				this.factoryForm.DataId=factory.row.DataID;
			})
			
		},
		close(){
			this.$refs['factoryForm'].resetFields()
		},
		restForm(){
			this.$nextTick(()=>{
				this.$refs['factoryForm'].resetFields()
			})
		},
		SetFactory(){
			this.$refs['factoryForm'].validate((isValidate)=>{
				if(isValidate){
					var user = JSON.parse(sessionStorage.getItem('user'));
					this.factoryForm.cid=user.QyNum
					if(this.dialogtype==1){
						//添加工厂
					this.$axios({
        				method: 'post',
        				url:'/FW/Factory.ashx',
        			params: {
          				action:"add",
          				factory:this.factoryForm
        			}
        			}).then(res=>{
          				if(res.Code==0){
							this.$message({
            				showClose: true,
            				message:res.Msg,
            				type: 'success'
							});
							this.SelFactory()
          				}else{
							this.$message({
            					showClose: true,
            					message:res.Msg,
            					type: 'warning'
            				});
          				}       
      				})
					}else if(this.dialogtype==2){
						//修改工厂
					this.$axios({
        				method: 'post',
        				url:'/FW/Factory.ashx',
        			params: {
          				action:"edit",
          				factory:this.factoryForm
        			}
        			}).then(res=>{
          				if(res.Code==0){
							this.$message({
            				showClose: true,
            				message:res.Msg,
            				type: 'success'
							});
							this.SelFactory()
          				}else{
							this.$message({
            					showClose: true,
            					message:res.Msg,
            					type: 'warning'
            				});
          				}       
      				})
					}
				}else{
					isValidate
				}
			})
		},
		SelFactory(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			//查询工厂
			this.$axios({
        		method: 'post',
        		url:'/FW/Factory.ashx',
        		params: {
          			action:"query",
					cid:user.QyNum,
					factoryName:this.selectfactoryForm.factoryName,
					factoryCode:this.selectfactoryForm.factoryCode,
					activeFlag:this.selectfactoryForm.isActive
        		}
        	}).then(res=>{
          		if(res.Code==0){
					this.tableData=res.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})		
		},
		delFactory(factory){
					//修改工厂
					this.$axios({
        				method: 'post',
        				url:'/FW/Factory.ashx',
        			params: {
          				action:"delete",
          				factory:factory.row
        			}
        			}).then(res=>{
          				if(res.Code==0){
							this.$message({
            				showClose: true,
            				message:res.Msg,
            				type: 'success'
							});
							this.SelFactory()
          				}else{
							this.$message({
            					showClose: true,
            					message:res.Msg,
            					type: 'warning'
            				});
          				}       
      				})
		}
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:10px 80px;
}
.el-input,.el-select{
	width:220px;
}
</style>


// WEBPACK FOOTER //
// src/pages/InListQS.vue